import type {TGamePlayer, TPlayerId} from '@kapitalist/contract/types'
import {DataBackedModel} from '~/models/base'
import type Hand from '~/models/game/Hand'
import type Portfolio from '~/models/game/Portfolio'

// represents all players at the table
//
// subclasses specify whether this is:
// - `ConcealedGamePlayer` (can't see their hand)
//    - some of which are `OpponentGamePlayer` ("not you", while you're playing)
// - `ExposedGamePlayer` (can see their hand)
//    - some of which are `CurrentGamePlayer` ("you", while you're playing).
export default abstract class GamePlayer extends DataBackedModel<TGamePlayer> {
  id: TPlayerId
  username: string
  email: string
  portfolio: Portfolio

  hand: Hand

  constructor(data: TGamePlayer, portfolio: Portfolio, hand: Hand) {
    super(data)
    this.id = data.playerId
    this.username = data.username
    this.email = data.email
    this.portfolio = portfolio
    this.hand = hand
  }
}
